module.exports = __webpack_public_path__ + "assets/skill-listening.4a299cd7.svg";